import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  mapWrapper: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 129px)',
    maxHeight: '100%',
    [breakpoints.up('xl')]: {
      height: 'calc(100vh - 120px)',
      maxHeight: '100%',
    },
  },
  mapWrapperScrolled: {
    [breakpoints.up('xl')]: {
      height: '100vh',
    },
  },
  mapContainerStyle: {
    width: '100%',
    height: '100%',
  },
  veevaNumber: {
    position: 'absolute',
    bottom: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
